module.exports = __webpack_public_path__ + "img/e42.206effe5.png";